export default __webpack_public_path__ + "static/media/4d.1f3a7201.png";